import { createRouter, createWebHistory, VueRouter } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AssetView from "../views/AssetView.vue";
import AssetDetailView from "../views/AssetDetailView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/asset",
    name: "asset",
    component: AssetView,
  },
  {
    path: "/asset/:slug",
    name: "AssetDetail",
    component: AssetDetailView,
  },
];

const router = createRouter({
  history: createWebHistory("/assets/"),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 };
  },
});

export default router;
